module.exports = __webpack_public_path__ + "media/newstyle/images/icon-mercadolivre-48c0410f781e8a054c560670b625d238.svg";